import EvalSelectUser from './src/main';

/* istanbul ignore next */
EvalSelectUser.install = function(Vue) {
  Vue.component(EvalSelectUser.name, EvalSelectUser);
};

export default EvalSelectUser;
